export default "__VITE_ASSET__6e32a2fb__"